<nav class="main-header navbar navbar-expand navbar-light navbar-success">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
        <li class="nav-item">
            <a class="nav-link" data-widget="pushmenu" href="#" role="button" (click)="toggleSidebar()"><i class="fas fa-bars"></i></a>
        </li>
    </ul>
    <div class="xhr-loader mr-auto ml-auto" [ngClass]="this.loaderService.spinnerVisible ? 'display-block' : 'display-none'"></div>
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
        <li class="nav-item">
            <a class="nav-link" data-widget="fullscreen" href="#" role="button">
                <i class="fas fa-expand-arrows-alt"></i>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-widget="control-sidebar" data-slide="true" href="#" role="button">
                <i class="fas fa-th-large"></i>
            </a>
        </li>
    </ul>
</nav>
